/**
 * Created by fyzu on 07.08.16.
 */

var AnimationsService = (function () {

    'use strict';

    //************ Variables ************//
    var timeline = {};

    //************ Functions ************//
    function basket() {
        timeline.basket.stop();
        timeline.basket.play();
    }

    function successOrder() {
        timeline.successOrder.play();
        setTimeout(function () {
            $('#js-success-cookie-animation').remove();
        }, 1510);
    }

    function init() {
        /* Animate basket img */
        var link = $('.js-basket-link');
        var tweens = [
            // burst animation
            new mojs.Burst({
                parent: link,
                duration: 1200,
                delay: 200,
                shape: 'circle',
                fill: '#eb1f40',
                opacity: 0.6,
                childOptions: {radius: {'rand(20,5)': 0}},
                radius: {45: 90},
                count: 18,
                isSwirl: true,
                swirlSize: 15,
                isRunLess: true,
                easing: mojs.easing.bezier(0.1, 1, 0.3, 1)
            }),
            // ring animation
            new mojs.Transit({
                parent: link,
                duration: 1500,
                type: 'circle',
                radius: {15: 50},
                fill: 'transparent',
                stroke: '#eb1f40',
                strokeWidth: {30: 0},
                opacity: 0.6,
                isRunLess: true,
                easing: mojs.easing.bezier(0.1, 1, 0.3, 1)
            })
        ];
        timeline.basket = new mojs.Timeline();
        for (var i = 0, len = tweens.length; i < len; ++i) {
            timeline.basket.add(tweens[i]);
        }
        /* Animate basket img END */

        /* Animate success img */
        var successEl = $('.js-success-cookie');
        if (successEl.length > 0) {
            var successAnimationEl = document.getElementById('js-success-cookie-animation');
            var successImgEl = document.getElementById('js-success-img');
            var successOpenImgEl = document.getElementById('js-success-open-img');
            tweens = [
                // burst animation
                new mojs.Burst({
                    parent: successAnimationEl,
                    count: 28,
                    radius: {100: 220},
                    children: {
                        fill: '#eb1f40',
                        opacity: 0.6,
                        radius: {'rand(10,40)': 0},
                        scale: 1,
                        swirlSize: 15,
                        duration: 1600,
                        easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
                        isSwirl: true
                    }
                }),
                // burst animation
                new mojs.Burst({
                    parent: successAnimationEl,
                    count: 18,
                    angle: {0: 20},
                    radius: {140: 200},
                    children: {
                        fill: '#eb1f40',
                        shape: 'line',
                        opacity: 0.6,
                        radius: {'rand(10,40)': 0},
                        scale: 1,
                        stroke: '#eb1f40',
                        strokeWidth: 2,
                        duration: 1800,
                        delay: 300,
                        easing: mojs.easing.bezier(0.1, 1, 0.3, 1)
                    }
                }),
                // burst animation
                new mojs.Burst({
                    parent: successAnimationEl,
                    radius: {80: 260},
                    count: 18,
                    children: {
                        fill: '#eb1f40',
                        opacity: 0.6,
                        radius: {'rand(10,40)': 0},
                        scale: 1,
                        swirlSize: 15,
                        duration: 2000,
                        delay: 500,
                        easing: mojs.easing.bezier(0.1, 1, 0.3, 1),
                        isSwirl: true
                    }
                }),
                // burst animation
                new mojs.Burst({
                    parent: successAnimationEl,
                    count: 20,
                    angle: {0: -10},
                    radius: {180: 260},
                    children: {
                        fill: '#eb1f40',
                        opacity: 0.6,
                        radius: {'rand(10,20)': 0},
                        scale: 1,
                        duration: 3000,
                        delay: 750,
                        easing: mojs.easing.bezier(0.1, 1, 0.3, 1)
                    }
                }),
                // icon scale animation
                new mojs.Tween({
                    duration: 1500,
                    easing: mojs.easing.back.out,
                    onUpdate: function (progress) {
                        successImgEl.style.opacity = 1 - progress;
                        successOpenImgEl.style.opacity = progress;
                    }
                })
            ];
            timeline.successOrder = new mojs.Timeline();
            for (var i = 0, len = tweens.length; i < len; ++i) {
                timeline.successOrder.add(tweens[i]);
            }
            /* Animate success img END */
        }
    }

    //************ Public ************//
    return {
        init: init,
        animate: {
            basket: basket,
            successOrder: successOrder
        }
    }
})();

$(AnimationsService.init);